import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import ColoredLabelsInBoardQuery, {
	type ColoredLabelsUpdaterQuery,
} from '@jira/software__board/src/colored-labels-updater/__generated__/ColoredLabelsUpdaterQuery.graphql';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

import type { RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_COLORED_LABELS_RELAY = 'COLORED_LABELS_RELAY';

export const coloredLabelsResource: RouteResource<
	PreloadedQuery<ColoredLabelsUpdaterQuery, Record<string, unknown>>
> = createRelayResource<ColoredLabelsUpdaterQuery>({
	type: RESOURCE_TYPE_COLORED_LABELS_RELAY,
	getQuery: ({ query, match }, { tenantContext }) => {
		const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;

		let boardAriId = null;

		try {
			boardAriId = boardId
				? `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`
				: '';
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'getBoardAriId',
					packageName: 'jiraSoftwareBoard',
					teamName: 'gryffindor',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		return {
			parameters: ColoredLabelsInBoardQuery,
			variables: {
				boardId: boardAriId || '',
			},
			options: { fetchPolicy: 'network-only' },
		};
	},
	isBrowserOnly: true,
});
